export default "__VITE_ASSET__X0uWKfR$__"